<template>
    <header
        class="TheNavbar"
    >
        <div class="Container">
            <a
                href="#"
                class="Profile"
                @click.prevent="$emit('onClickUser')"
            >
                <img
                    src="~@/assets/images/user.png"
                    alt="profile"
                >
            </a>
            <div
                class="Links"
            >
                <RouterLink
                    v-for="(link, index) in mainLinks"
                    :key="`navbarLink${index}`"
                    class="Link"
                    :to="link.to"
                >
                    {{ link.text }}
                </RouterLink>
            </div>
            <div class="Brand">
                <WIcon
                    clickable
                    icon="exit"
                    color="white"
                    :size="28"
                    @click="$emit('onExit')"
                />
            </div>
        </div>
    </header>
</template>

<script>
import ConfigMenu from '@/config/menu'

export default {
    name: 'TheNavbar',
    data () {
        return {
            mainLinks: ConfigMenu.links,
        }
    },
}
</script>

<style scoped lang="scss">
.TheNavbar {
    display: flex;
    justify-content: stretch;
    align-items: center;
    height: $navbar-height;
    background: $navbar-bg;
    color: $navbar-color;
    box-shadow: 0 3px 6px 0 rgba($primary, 0.1);
    z-index: $zindex-navbar;
}

.Container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    width: 100%;
    height: 100%;
    padding: 0 15px;
}

.Profile, .Brand {
    min-width: 50px;
}

.Profile {
    display: inline-block;

    img {
        position: relative;
        top: 2px;
        height: 40px;
        width: auto;
    }
}

.Logo {
    display: inline-block;
    img {
        position: relative;
        top: 2px;
        height: 50px;
        width: auto;
    }
}

.Links {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    height: 100%;
}

.Link {
    position: relative;
    display: inline-block;
    margin: 0 10px 3px;
    padding: 5px 10px;
    color: $navbar-color;
    font-size: 12px;
    font-weight: $font-weight-semibold;
    letter-spacing: 1px;
    text-transform: uppercase;

    @media screen and (min-width: $md) {
        margin: 0 10px 5px;
        padding: 5px 15px;
        font-size: 14px;
        letter-spacing: 1.5px;
    }

    @media screen and (min-width: $xl) {
        padding: 5px 30px;
    }

    &:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -5px;
        height: 0;
        width: 100%;
        border-radius: $border-radius;
        background: $white;
        transition: all $transition;
    }
    &:hover,
    &:active,
    &:focus,
    &.active,
    &.router-link-active {
        &:after {
            height: 5px;
        }
    }
}
</style>
